import { useEffect, useState, useRef } from "react";
import { Dialog } from "primereact/dialog";
import LinkHandler from "./LinkHandler.tsx";
import APIRequestDialog from "./ApiRequestDialog.tsx";
import { useFlowStore } from "../../store/FlowStateStore.ts";
import { CanvasNode, CanvasNodeData } from "../../models/CanvasNode.ts";
import binIcon from "../../assets/bin.png";

interface StatusFallback {
    statusText: string;
    source: string;
    target?: string;
    isFallback: boolean;
}

const APIRequest: React.FC<any> = (data) => {

    const [statusBtn, setStatusBtn] = useState<StatusFallback[]>([]);
    const [showDialog, setShowDialog] = useState<boolean>(false);
    const { nodes, setNodes, businessId } = useFlowStore();
    const [requestMethod, setRequestMethod] = useState<string>("GET");
    const [content, setContent] = useState<any>();
    const [url, setURL] = useState<string>("");
    const [bodyJson, setBodyJson] = useState({});
    const isLoaded = useRef(false);

    useEffect(()=> {
        const node = nodes.find(n => n.data.id === data.nodeId);
        if (node) {
            const nodeContent = (node.data as CanvasNodeData).content.find(c => c.id === data.subNodeId);
            if (nodeContent && nodeContent.data) {
                const contentData = nodeContent.data as any;
                setContent(contentData);
                setURL(contentData.requestObject?.url ?? "");
                setBodyJson(contentData.requestObject?.payload ?? "");
                setRequestMethod(contentData.requestObject?.method ?? "GET");
                if (contentData.statusCodes && contentData.statusCodes.length > 0) {
                    setStatusBtn(contentData.statusCodes);
                } else {
                    // Only initialize default if none exist in store
                    setStatusBtn([{ statusText: "Status Fallback", source: crypto.randomUUID(), target: '', isFallback: true }]);
                }
            }
        }
        isLoaded.current = true;
    }, []);

    useEffect(() => {
        if (!isLoaded.current) return;
        const updatedNodes = nodes.map((node) => {
            if (node.data.id == data.nodeId) {
                return {
                    ...node,
                    data: {
                        ...node.data,
                        content: [...(node.data as CanvasNodeData).content.map((nodeContent) => {
                            if (nodeContent.id == data.subNodeId) {
                                return {
                                    ...nodeContent,
                                    data: {
                                        ...nodeContent.data,
                                        statusCodes: statusBtn
                                    }
                                }
                            }
                            return nodeContent
                        })]
                    }
                }
            }
            return node;
        });

        setNodes([...(updatedNodes as CanvasNode[])]);

    }, [statusBtn]);

    const removeBtn = (idx: number) => {
        setStatusBtn(statusBtn.filter((_, index) => index != idx));
    }
    const addStatusBtn = (event: React.MouseEvent) => {
        const button: StatusFallback = {
            statusText: '200',
            source: crypto.randomUUID(),
            isFallback: false
        }
        setStatusBtn([...statusBtn, button]);
    }
    const onClose = (event: any) => {
        setShowDialog(false);
    }

    return (
        <>
            <div className="node-body">
                <div>
                    <span className="font-label">API Request URL</span>
                    <input type="text" placeholder="Webhook URL" value={url} onChange={(event)=> setURL(event?.target.value)} />
                    <div>
                        {statusBtn.map((status, idx) => {
                            return (
                                <div style={{ position: 'relative' }}>
                                    {!status.isFallback && <img onClick={() => removeBtn(idx)} src={binIcon} style={{ cursor: 'pointer', height: '10px', position: 'absolute', top: '5px', left: '2px' }} />}
                                    <input className="status-btn" type="number" placeholder={status.statusText} value={status.statusText}
                                        onChange={(e) =>
                                            setStatusBtn(prev =>
                                            prev.map((s, i) =>
                                                i === idx ? { ...s, statusText: e.target.value } : s
                                            )
                                            )
                                        } 
                                    />
                                    <LinkHandler idx={status.source} />
                                </div>
                            )
                        })}
                    </div>
                    <button onClick={(event) => addStatusBtn(event)} className="font-label add-content">+ Custom Status Code</button>
                    <button onClick={() => setShowDialog(true)} className="font-label add-content">Edit API Request</button>
                </div>
            </div>
            <Dialog
                header="API Request"
                visible={showDialog}
                modal
                appendTo={document.body}
                maskStyle={{
                    background: "rgba(0,0,0,0.6)",
                    zIndex: 9998,
                }}
                contentStyle={{ zIndex: 9999 }}
                style={{ width: "80vw", maxWidth: "1000px" }}
                onHide={() => setShowDialog(false)}
            >
                <APIRequestDialog data={data} onClose={onClose} />
            </Dialog>
        </>
    )
}

export default APIRequest;
